import { func, string } from "prop-types";
import { security } from "./security";
import { parse } from "date-fns";

export function configuration() {
  return {
    company: "444",
    urlBase: "https://api.digitalcredit.app",
     token:
      "eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJhY3RvcnQiOiIzMDAiLCJ1bmlxdWVfbmFtZSI6IkFwaSBTZWN1cml0eSIsInJvbGUiOiI3OSIsImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL3N5c3RlbSI6IjE0IiwibmFtZWlkIjoiZGlnaXRhbGNyZWRpdC5teCIsImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL3VyaSI6ImFwaS5kaWdpdGFsY3JlZGl0LmFwcCIsImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL2F1dGhvcml6YXRpb25kZWNpc2lvbiI6IjEiLCJuYmYiOjE2OTcxMzY2ODcsImV4cCI6MTcyODY3MjY4NywiaWF0IjoxNjk3MTM2Njg3fQ.WFwbRLb7l-nAYRknRKD8OaNovlxKvxSe_DrOpZQEl9F_jeXhxziP933r7unv5Lz0oxcI4MT12D4IvLyOT3SaOQ",
    // urlBase: "https://api.digitalcreditlab.com",
    // token:
    //  "eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJhY3RvcnQiOiIzMDAiLCJ1bmlxdWVfbmFtZSI6IkFwaSBTZWN1cml0eSIsInJvbGUiOiIxIiwiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvc3lzdGVtIjoiMTQiLCJuYW1laWQiOiJkaWdpdGFsY3JlZGl0Lm14IiwiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvdXJpIjoiYXBpLmRpZ2l0YWxjcmVkaXRsYWIuY29tIiwiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvYXV0aG9yaXphdGlvbmRlY2lzaW9uIjoiMSIsIm5iZiI6MTcwMDY5NTg1OCwiZXhwIjoxNzMyMjMxODU4LCJpYXQiOjE3MDA2OTU4NTh9.SGkevf7tapZDSnlHmo52_CW9Edxqx8AwXXkeFaSIouf0VWeKejD5q_9k-2zxvQ09Lz4cXS7F3mfrexT85xlMWw",
  };
}

export async function getLiterales(servelt, company, language) {
  const params = JSON.stringify({
    language: language,
    company: company,
    chanel: "4",
    servelt_id: servelt,
  });
  var url = configuration().urlBase + "/generic/Literales/getLiterales";
  var sToken = isNullOrEmpty(security.tokens.generic)
    ? configuration().token
    : security.tokens.generic;

  const requestOptions = {
    method: "POST",
    mode: "cors",
    headers: {
      "Access-Control-Allow-Origin": "*",
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + sToken,
    },
    body: params,
  };

  let res = await fetch(url, requestOptions);

  let data = await res.json();

  return data.result;
}

export async function consumeApi(requestMethod, apiMethod, params) {
  var url = configuration().urlBase + apiMethod;

  var sToken = "";

  if (apiMethod.toUpperCase().includes("GENERIC")) {
    sToken = security.tokens.generic;
  } else if (apiMethod.toUpperCase().includes("SECURITY")) {
    sToken = isNullOrEmpty(security.tokens.security)
      ? configuration().token
      : security.tokens.security;
  } else if (apiMethod.toUpperCase().includes("CORE")) {
    sToken = security.tokens.core;
  } else if (apiMethod.toUpperCase().includes("MIAPP")) {
    sToken = security.tokens.miApp;
  } else if (apiMethod.toUpperCase().includes("GATEWAY")) {
    sToken = security.tokens.gateway;
  } else if (apiMethod.toUpperCase().includes("NOTIFICATION")) {
    sToken = security.tokens.notification;
  } else if (apiMethod.toUpperCase().includes("INTEGRATION")) {
    sToken = security.tokens.integration;
  }

  const requestOptions = {
    method: requestMethod,
    mode: "cors",
    headers: {
      "Access-Control-Allow-Origin": "*",
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + sToken,
    },
  };

  if (requestMethod == "POST") {
    requestOptions.body = params;
  }

  try {
    let res = await fetch(url, requestOptions);
    let data = await res.json();

    if (data.code != "200") throw data.result;

    return data.result;
  } catch (ex) {
    return "error:" + ex;
  }
}

export async function getTokens(company) {
  const url = "/security/Token/Token";

  var params = {
    id: "API CORE",
    company: company,
  };

  var token = await consumeApi("POST", url, JSON.stringify(params));

  if (!String(token).includes("error")) {
    security.tokens.core = token;
  }

  params.id = "API GENERIC";

  token = await consumeApi("POST", url, JSON.stringify(params));

  if (!String(token).includes("error")) {
    security.tokens.generic = token;
  }

  params.id = "API SECURITY";

  token = await consumeApi("POST", url, JSON.stringify(params));

  if (!String(token).includes("error")) {
    security.tokens.security = token;
  }

  params.id = "API MIAPP";

  token = await consumeApi("POST", url, JSON.stringify(params));

  if (!String(token).includes("error")) {
    security.tokens.miApp = token;
  }
  params.id = "API GATEWAY";

  token = await consumeApi("POST", url, JSON.stringify(params));

  if (!String(token).includes("error")) {
    security.tokens.gateway = token;
  }
  params.id = "API NOTIFICATION";

  token = await consumeApi("POST", url, JSON.stringify(params));

  if (!String(token).includes("error")) {
    security.tokens.notification = token;
  }

  params.id = "API INTEGRATION";

  token = await consumeApi("POST", url, JSON.stringify(params));

  if (!String(token).includes("error")) {
    security.tokens.integration = token;
  }
}

export function setLiteral(lsLiterales, IdLiteral) {
  try {
    var literal = lsLiterales.find(
      (element) => element.iD_LITERAL === IdLiteral
    ).literal;

    // literal = literal.replace("<strong>", "");
    // literal = literal.replace("</strong>", "");

    return literal;
  } catch (error) {
    return "";
  }
}

export function setLiteral2(lsLiterales, IdLiteral) {
  try {
    var literal = lsLiterales.find(
      (element) => element.iD_LITERAL === IdLiteral
    ).literal;

    // literal = literal.replace("<strong>", "");
    // literal = literal.replace("</strong>", "");
    literal = literal.toString();
    literal = literal.toLowerCase();
    return literal;
  } catch (error) {
    return "";
  }
}
function borrarUltimoDigito(cadena) {
  if (cadena.length > 0) {
    return cadena.slice(0, -1);
  }
  return cadena;
}

export function setLiteral3(lsLiterales, IdLiteral) {
  try {
    var literal = lsLiterales.find(
      (element) => element.iD_LITERAL === IdLiteral
    ).literal;

    // literal = literal.replace("<strong>", "");
    // literal = literal.replace("</strong>", "");
    literal = literal.toString();
    literal = borrarUltimoDigito(literal);
    return literal;
  } catch (error) {
    return "";
  }
}

export function onlyNumbers(text) {
  return text.replace(/[^0-9]/g, "");
}

export function onlyDecimals(text) {
  try {
    return text.replace(/[^\d\.]/g, "").replace(/\.(([^\.]*)\.)*/g, ".$2");
  } catch (error) {
    return text;
  }
}

export function isNullOrEmpty(text) {
  if (text && text != "") {
    return false;
  } else {
    return true;
  }
}

export function alphaNumeric(text) {
  return text.replace(/[^a-zA-Z 0-9]/g, "");
}

export function inputAmount(text) {
  return text.replace(/[^\d\.]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function validateEmail(mail) {
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
    return true;
  }
}

export function getDate() {
  const today = new Date();
  const formattedDate = today.toLocaleDateString("es-ES", {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
  });
  const ff = formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
  return ff;
}

export function diferenciaMeses(fechaStr1, fechaStr2) {
  const fecha1 = new Date(fechaStr1);
  const fecha2 = new Date(fechaStr2);

  const anio1 = fecha1.getFullYear();
  const anio2 = fecha2.getFullYear();

  const mes1 = fecha1.getMonth();
  const mes2 = fecha2.getMonth();

  return (anio2 - anio1) * 12 + (mes2 - mes1);
}

export function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}

export function fechaRecortada(fecha) {
  const fecha_n = new Date(fecha);

  if (isNaN(fecha_n.getTime())) {
    return ""; // Retorna una cadena vacía si la fecha no es válida
  }

  const day = String(fecha_n.getDate()).padStart(2, "0");
  const month = String(fecha_n.getMonth() + 1).padStart(2, "0");
  const year = String(fecha_n.getFullYear());

  return `${day}-${month}-${year}`;
}

export function newAmount(amount) {
  let nAmount = parseFloat(amount);

  if (nAmount < 0) {
    nAmount = 0;
  } else {
    nAmount.toFixed(2);
  }
  return `$${numberFormat(nAmount)}`;
}

export function numberFormat(number) {
  return String(number).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function removeHtmlTags(str) {
  let str1 = String(str);
  return str1.replace(/<\/?[^>]+(>|$)/g, "").replace(/:/g, "");
}

export function obtenerTextoAntesDeHTML(cadena) {
  const regex = /^(.*?)</;
  let cadena1 = String(cadena);
  const coincidencia = cadena1.match(regex);
  return coincidencia ? coincidencia[1].trim() : "";
}

export function sentenceFormat(texto) {
  if (!texto) return ""; // Manejo de cadena vacía
  return texto.charAt(0).toUpperCase() + texto.slice(1).toLowerCase();
}

export function prueba(text) {
  return text.bold();
}
